import React from 'react';
import { useNavigate } from 'react-router-dom';

const GeneralSettingsPage = () => {
  const navigate = useNavigate();

  const settingsOptions = [
    {
      title: 'Sites',
      description: 'Manage organization sites and locations',
      icon: '🏢',
      path: '/admin/sites',
    },
    {
      title: 'Departments',
      description: 'Manage departments and organizational units',
      icon: '🏛️',
      path: '/admin/departments',
    },
    {
      title: 'Categories',
      description: 'Manage asset categories and classifications',
      icon: '📁',
      path: '/admin/categories',
    },
    {
      title: 'Locations',
      description: 'Manage physical locations and storage areas',
      icon: '📍',
      path: '/admin/locations',
    },
    {
      title: 'User Roles & Permissions',
      description: 'Manage permissions for Admin and Employee roles',
      icon: '🔐',
      path: '/admin/settings/user-roles',
    },
    {
      title: 'General Settings',
      description: 'Configure general application settings',
      icon: '⚙️',
      path: '/admin/settings/general',
    },
    {
      title: 'Column Setup',
      description: 'Customize table columns display',
      icon: '📊',
      path: '/admin/settings/columns',
    },
    {
      title: 'Job Types',
      description: 'View all available job types',
      icon: '🧩',
      path: '/admin/settings/job-types',
    },
    {
      title: 'Feedback Parameters',
      description: 'View all feedback parameters',
      icon: '📝',
      path: '/admin/settings/feedback-parameters',
    },
  ];

  return (
    <div className="general-settings-page" style={{ padding: '16px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
        {settingsOptions.map((option, index) => (
          <div
            key={index}
            onClick={() => navigate(option.path)}
            style={{
              background: 'white',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'all 0.2s',
              border: '2px solid transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#667eea';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>{option.icon}</div>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: '#2d3748' }}>
              {option.title}
            </h3>
            <p style={{ margin: 0, color: '#718096', fontSize: '13px' }}>
              {option.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralSettingsPage;
